import Alpine from "alpinejs";
import { FeatureFlagService } from "@src/js/services/featureFlagService";
Alpine.data("featureFlags", () => ({
    data: [],
    page: 1,
    pageSize: 10,
    modalOpen: false,
    newFlag: { name: '', description: '', enabled: true },
    async init() {
        this.data = await FeatureFlagService.getAll();
    },
    get paginatedData() {
        const start = (this.page - 1) * this.pageSize;
        return this.data.slice(start, start + this.pageSize);
    },
    get pageCount() {
        return Math.ceil(this.data.length / this.pageSize);
    },
    openCreateModal() {
        this.modalOpen = true;
        this.newFlag = { name: '', description: '', enabled: true };
    },
    closeCreateModal() {
        this.modalOpen = false;
    },
    async createFlag() {
        try {
            const saved = await FeatureFlagService.save(this.newFlag);
            this.data.unshift(saved);
            this.closeCreateModal();
        }
        catch (err) {
            alert(err.message);
        }
    },
    async deleteFlag(id) {
        if (!confirm('Really delete this feature flag?'))
            return;
        try {
            await FeatureFlagService.delete(id);
            this.data = this.data.filter(f => f._id !== id);
        }
        catch (err) {
            alert(err.message);
        }
    }
}));
